// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
  background: #f3f6fb;
  color: #0f172a;
  font-family: Poppins, sans-serif;
}

.home-page .section-container,
.home-page .banner-container {
  width: min(1180px, 94%);
  margin: 0 auto;
}

.home-page .section-header {
  text-align: center;
  margin-bottom: 28px;
}

.home-page .section-label {
  display: inline-block;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #16a34a;
}

.home-page .section-title {
  margin: 8px 0 0;
  font-size: clamp(1.9rem, 3.2vw, 3rem);
  line-height: 1.15;
  color: #0f1d39;
}

.home-page .section-description {
  margin: 12px auto 0;
  max-width: 760px;
  color: #475569;
  font-size: 1.04rem;
  line-height: 1.65;
}

.home-page .why-udaan-section {
  padding: 64px 0 58px;
}

.home-page .features-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
}

@media (min-width: 760px) {
  .home-page .features-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1120px) {
  .home-page .features-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.home-page .feature-card {
  background: #ffffff;
  border: 1px solid #dbe3ef;
  border-radius: 16px;
  padding: 22px 20px;
  box-shadow: 0 10px 20px rgba(15, 35, 68, 0.07);
}

.home-page .feature-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}

.home-page .feature-icon .material-icons {
  font-size: 1.25rem;
}

.home-page .blue-icon {
  background: #dbeafe;
  color: #2563eb;
}

.home-page .green-icon {
  background: #dcfce7;
  color: #15803d;
}

.home-page .orange-icon {
  background: #ffedd5;
  color: #ea580c;
}

.home-page .purple-icon {
  background: #ede9fe;
  color: #7c3aed;
}

.home-page .pink-icon {
  background: #fce7f3;
  color: #db2777;
}

.home-page .teal-icon {
  background: #ccfbf1;
  color: #0f766e;
}

.home-page .feature-title {
  margin: 0;
  font-size: 1.2rem;
  color: #0f1d39;
}

.home-page .feature-text {
  margin: 10px 0 0;
  color: #475569;
  line-height: 1.6;
  font-size: 0.97rem;
}

.home-page .courses-section {
  padding: 58px 0;
  background: #eef3f9;
  border-top: 1px solid #dde5f0;
  border-bottom: 1px solid #dde5f0;
}

.home-page .courses-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 14px;
  margin-bottom: 26px;
}

.home-page .courses-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
}

@media (min-width: 760px) {
  .home-page .courses-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1120px) {
  .home-page .courses-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.home-page .course-card {
  background: #ffffff;
  border: 1px solid #dbe3ef;
  border-radius: 16px;
  padding: 22px 18px;
  box-shadow: 0 10px 20px rgba(15, 35, 68, 0.06);
}

.home-page .course-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.home-page .course-icon .material-icons {
  font-size: 1.2rem;
}

.home-page .green-course {
  background: #dcfce7;
  color: #15803d;
}

.home-page .blue-course {
  background: #dbeafe;
  color: #2563eb;
}

.home-page .orange-course {
  background: #ffedd5;
  color: #ea580c;
}

.home-page .purple-course {
  background: #ede9fe;
  color: #7c3aed;
}

.home-page .course-name {
  margin: 0;
  font-size: 1.16rem;
  color: #0f1d39;
}

.home-page .course-features {
  margin: 12px 0 0;
  padding-left: 18px;
  color: #475569;
  display: grid;
  gap: 7px;
  min-height: 92px;
}

.home-page .course-link {
  display: inline-flex;
  margin-top: 12px;
  color: #1d4ed8;
  font-weight: 700;
  text-decoration: none;
}

.home-page .faculty-section {
  padding: 62px 0;
}

.home-page .faculty-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 26px;
  align-items: center;
}

@media (min-width: 1020px) {
  .home-page .faculty-content {
    grid-template-columns: 0.9fr 1.1fr;
  }
}

.home-page .faculty-image {
  position: relative;
}

.home-page .faculty-img {
  width: 100%;
  border-radius: 18px;
  border: 1px solid #dbe3ef;
  box-shadow: 0 14px 24px rgba(15, 35, 68, 0.11);
  display: block;
}

.home-page .experience-badge {
  position: absolute;
  left: 16px;
  bottom: 16px;
  background: #ffffff;
  border: 1px solid #dbe3ef;
  border-radius: 12px;
  padding: 10px 12px;
  box-shadow: 0 6px 14px rgba(15, 35, 68, 0.12);
}

.home-page .badge-number {
  font-size: 1.2rem;
  font-weight: 800;
  color: #0f1d39;
}

.home-page .badge-text {
  font-size: 0.78rem;
  color: #475569;
}

.home-page .faculty-description {
  margin: 12px 0 0;
  color: #475569;
  line-height: 1.65;
}

.home-page .faculty-points {
  margin-top: 18px;
  display: grid;
  gap: 14px;
}

.home-page .faculty-point {
  display: grid;
  grid-template-columns: 44px 1fr;
  gap: 12px;
}

.home-page .point-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.home-page .point-icon .material-icons {
  font-size: 1.2rem;
}

.home-page .blue-point {
  background: #dbeafe;
  color: #2563eb;
}

.home-page .green-point {
  background: #dcfce7;
  color: #15803d;
}

.home-page .orange-point {
  background: #ffedd5;
  color: #ea580c;
}

.home-page .point-title {
  margin: 0;
  color: #0f1d39;
  font-size: 1rem;
}

.home-page .point-text {
  margin: 6px 0 0;
  color: #475569;
  font-size: 0.94rem;
  line-height: 1.55;
}

.home-page .scholarship-banner {
  padding: 46px 0;
  background: linear-gradient(90deg, #15386d 0%, #284f92 100%);
  color: #ffffff;
}

.home-page .banner-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  align-items: center;
}

@media (min-width: 920px) {
  .home-page .banner-content {
    grid-template-columns: 1fr auto;
  }
}

.home-page .banner-title {
  margin: 0;
  font-size: clamp(1.7rem, 3vw, 2.4rem);
}

.home-page .banner-description {
  margin: 8px 0 0;
  color: #d3e1ff;
  line-height: 1.6;
}

.home-page .scholarship-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0 20px;
  border-radius: 10px;
  border: none;
  background: #f59e0b;
  color: #ffffff;
  text-decoration: none;
  white-space: nowrap;
  font-weight: 700;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./home/home.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;;EAEE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".home-page {\n  background: #f3f6fb;\n  color: #0f172a;\n  font-family: Poppins, sans-serif;\n}\n\n.home-page .section-container,\n.home-page .banner-container {\n  width: min(1180px, 94%);\n  margin: 0 auto;\n}\n\n.home-page .section-header {\n  text-align: center;\n  margin-bottom: 28px;\n}\n\n.home-page .section-label {\n  display: inline-block;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #16a34a;\n}\n\n.home-page .section-title {\n  margin: 8px 0 0;\n  font-size: clamp(1.9rem, 3.2vw, 3rem);\n  line-height: 1.15;\n  color: #0f1d39;\n}\n\n.home-page .section-description {\n  margin: 12px auto 0;\n  max-width: 760px;\n  color: #475569;\n  font-size: 1.04rem;\n  line-height: 1.65;\n}\n\n.home-page .why-udaan-section {\n  padding: 64px 0 58px;\n}\n\n.home-page .features-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 18px;\n}\n\n@media (min-width: 760px) {\n  .home-page .features-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1120px) {\n  .home-page .features-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.home-page .feature-card {\n  background: #ffffff;\n  border: 1px solid #dbe3ef;\n  border-radius: 16px;\n  padding: 22px 20px;\n  box-shadow: 0 10px 20px rgba(15, 35, 68, 0.07);\n}\n\n.home-page .feature-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 14px;\n}\n\n.home-page .feature-icon .material-icons {\n  font-size: 1.25rem;\n}\n\n.home-page .blue-icon {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.home-page .green-icon {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.home-page .orange-icon {\n  background: #ffedd5;\n  color: #ea580c;\n}\n\n.home-page .purple-icon {\n  background: #ede9fe;\n  color: #7c3aed;\n}\n\n.home-page .pink-icon {\n  background: #fce7f3;\n  color: #db2777;\n}\n\n.home-page .teal-icon {\n  background: #ccfbf1;\n  color: #0f766e;\n}\n\n.home-page .feature-title {\n  margin: 0;\n  font-size: 1.2rem;\n  color: #0f1d39;\n}\n\n.home-page .feature-text {\n  margin: 10px 0 0;\n  color: #475569;\n  line-height: 1.6;\n  font-size: 0.97rem;\n}\n\n.home-page .courses-section {\n  padding: 58px 0;\n  background: #eef3f9;\n  border-top: 1px solid #dde5f0;\n  border-bottom: 1px solid #dde5f0;\n}\n\n.home-page .courses-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 14px;\n  margin-bottom: 26px;\n}\n\n.home-page .courses-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 18px;\n}\n\n@media (min-width: 760px) {\n  .home-page .courses-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1120px) {\n  .home-page .courses-grid {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n.home-page .course-card {\n  background: #ffffff;\n  border: 1px solid #dbe3ef;\n  border-radius: 16px;\n  padding: 22px 18px;\n  box-shadow: 0 10px 20px rgba(15, 35, 68, 0.06);\n}\n\n.home-page .course-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n}\n\n.home-page .course-icon .material-icons {\n  font-size: 1.2rem;\n}\n\n.home-page .green-course {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.home-page .blue-course {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.home-page .orange-course {\n  background: #ffedd5;\n  color: #ea580c;\n}\n\n.home-page .purple-course {\n  background: #ede9fe;\n  color: #7c3aed;\n}\n\n.home-page .course-name {\n  margin: 0;\n  font-size: 1.16rem;\n  color: #0f1d39;\n}\n\n.home-page .course-features {\n  margin: 12px 0 0;\n  padding-left: 18px;\n  color: #475569;\n  display: grid;\n  gap: 7px;\n  min-height: 92px;\n}\n\n.home-page .course-link {\n  display: inline-flex;\n  margin-top: 12px;\n  color: #1d4ed8;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.home-page .faculty-section {\n  padding: 62px 0;\n}\n\n.home-page .faculty-content {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 26px;\n  align-items: center;\n}\n\n@media (min-width: 1020px) {\n  .home-page .faculty-content {\n    grid-template-columns: 0.9fr 1.1fr;\n  }\n}\n\n.home-page .faculty-image {\n  position: relative;\n}\n\n.home-page .faculty-img {\n  width: 100%;\n  border-radius: 18px;\n  border: 1px solid #dbe3ef;\n  box-shadow: 0 14px 24px rgba(15, 35, 68, 0.11);\n  display: block;\n}\n\n.home-page .experience-badge {\n  position: absolute;\n  left: 16px;\n  bottom: 16px;\n  background: #ffffff;\n  border: 1px solid #dbe3ef;\n  border-radius: 12px;\n  padding: 10px 12px;\n  box-shadow: 0 6px 14px rgba(15, 35, 68, 0.12);\n}\n\n.home-page .badge-number {\n  font-size: 1.2rem;\n  font-weight: 800;\n  color: #0f1d39;\n}\n\n.home-page .badge-text {\n  font-size: 0.78rem;\n  color: #475569;\n}\n\n.home-page .faculty-description {\n  margin: 12px 0 0;\n  color: #475569;\n  line-height: 1.65;\n}\n\n.home-page .faculty-points {\n  margin-top: 18px;\n  display: grid;\n  gap: 14px;\n}\n\n.home-page .faculty-point {\n  display: grid;\n  grid-template-columns: 44px 1fr;\n  gap: 12px;\n}\n\n.home-page .point-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.home-page .point-icon .material-icons {\n  font-size: 1.2rem;\n}\n\n.home-page .blue-point {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.home-page .green-point {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.home-page .orange-point {\n  background: #ffedd5;\n  color: #ea580c;\n}\n\n.home-page .point-title {\n  margin: 0;\n  color: #0f1d39;\n  font-size: 1rem;\n}\n\n.home-page .point-text {\n  margin: 6px 0 0;\n  color: #475569;\n  font-size: 0.94rem;\n  line-height: 1.55;\n}\n\n.home-page .scholarship-banner {\n  padding: 46px 0;\n  background: linear-gradient(90deg, #15386d 0%, #284f92 100%);\n  color: #ffffff;\n}\n\n.home-page .banner-content {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  align-items: center;\n}\n\n@media (min-width: 920px) {\n  .home-page .banner-content {\n    grid-template-columns: 1fr auto;\n  }\n}\n\n.home-page .banner-title {\n  margin: 0;\n  font-size: clamp(1.7rem, 3vw, 2.4rem);\n}\n\n.home-page .banner-description {\n  margin: 8px 0 0;\n  color: #d3e1ff;\n  line-height: 1.6;\n}\n\n.home-page .scholarship-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 48px;\n  padding: 0 20px;\n  border-radius: 10px;\n  border: none;\n  background: #f59e0b;\n  color: #ffffff;\n  text-decoration: none;\n  white-space: nowrap;\n  font-weight: 700;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
